<div>
  <svg fill="none" height="24" viewBox="0 0 23 24" width="23" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip1)">
      <path
        d="M11.0696 11.461C14.2043 11.461 16.7513 8.91403 16.7513 5.77934C16.7513 2.64464 14.2043 0.097705 11.0696 
        0.097705C7.93494 -0.000254184 5.29004 2.54668 5.29004 5.68138C5.29004 8.91403 7.93494 11.461 11.0696 11.461Z"
        fill="white"
        fill-opacity="0.75"
      />
      <path
        d="M21.1592 23.9998H0.979592C0.391837 23.9998 0 23.608 0 23.0202V20.3753C0 16.6529 2.93878 13.7141 6.66123 
        13.7141H15.4776C19.102 13.7141 22.1388 16.6529 22.1388 20.3753V23.0202C22.1388 23.608 21.649 23.9998 21.1592 23.9998Z"
        fill="white"
        fill-opacity="0.75"
      />
    </g>
    <defs>
      <clipPath id="clip1">
        <rect fill="white" height="24" transform="translate(0 -0.000244141)" width="22.1388" />
      </clipPath>
    </defs>
  </svg>
</div>
